import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/var/jenkins_home/workspace/pdf_one_web/layouts/default.vue").then(m => m.default || m)),
  "edit-layout": defineAsyncComponent(() => import("/var/jenkins_home/workspace/pdf_one_web/layouts/editLayout.vue").then(m => m.default || m)),
  empty: defineAsyncComponent(() => import("/var/jenkins_home/workspace/pdf_one_web/layouts/empty.vue").then(m => m.default || m)),
  "test-layout": defineAsyncComponent(() => import("/var/jenkins_home/workspace/pdf_one_web/layouts/testLayout.vue").then(m => m.default || m))
}